import { FC } from "react";
import './ProgressBar.styles.scss';

const ProgressBar: FC = () => {
    return (
        <div className="ProgressBar"/>
    );
};

export default ProgressBar;